<template>
  <el-form
    ref="ruleForm"
    v-loading="loading"
    :model="ruleForm"
    size="small"
    :rules="rules"
    label-position="top"
  >
    <!-- 供应商 -->
    <el-form-item :label="$t('GlobalSetObj.supplier')">
      <span>{{ providerName }}</span>
    </el-form-item>
    <!-- 邮件 -->
    <el-form-item :label="$t('bank.email')" prop="email">
      <el-input
        v-model.trim="ruleForm.email"
        type="textarea"
        :rows="4"
        disabled
        :placeholder="$t('receivablePayable.multipleEmailsSeparatedByComma')"
      />
    </el-form-item>
    <el-form-item style="text-align: end;">
      <el-button @click="() =>onClose(false)">{{ $t('GlobalSetObj.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('GlobalSetObj.determine') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
// import { getSupplierMainInfo } from '@/api/SupplierMain';
import { apiSitePayableSendMail } from '@/api/finance/receivables';

const RES_OBJ = {
  callBackUrl: `${document.location.origin}/finance/payableManagement/UploadContas`, // 外链地址
  // callBackUrl: `http://192.168.2.20:9529/finance/payableManagement/UploadContas`, // 外链地址
  payableNumberList: [] // 批次号
  // payableNumber: '', // 批次号
  // providerMail: '' // 邮箱
};

export default {
  name: '',

  props: {
    row: {
      type: Object,
      required: true
    }
  },

  data() {
    // 单个邮箱校验
    const isValidEmail = (email) => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    };

    const validateEmails = (rule, value, callback) => {
      if (!value.trim()) {
        callback();
        return;
      }

      if (value.includes('，')) {
        callback(new Error(this.$t('receivablePayable.useEnglishComma')));
        callback();
        return;
      }

      const emails = value.split(',').map((email) => email.trim());
      const invalidEmails = emails.filter((email) => !isValidEmail(email));

      if (invalidEmails.length > 0) {
        const str = this.$t('receivablePayable.invalidEmailFormat');
        callback(new Error(`${str}：${invalidEmails.join(', ')}`));
      } else {
        callback();
      }
    };

    return {
      providerName: '', // 供应商名称
      ruleForm: {
        email: ''
      },

      rules: {
        email: [
          { required: true, message: ' ', trigger: ['change', 'blur'] },
          { validator: validateEmails, trigger: ['change', 'blur'] }
        ]
      },

      loading: false
    };
  },

  watch: {
    row: {
      handler(val) {
        console.log('row', val);
        this.providerName = val.providerName;
        this.ruleForm.email = val.providerCompanyEmail || '';
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    // this.asyncApiProviderIds();
  },

  methods: {
    // 根据供应商id获取供应商信息
    // asyncApiProviderIds() {
    //   const { providerId } = this.row;
    //   this.loading = false;
    //   getSupplierMainInfo(providerId).then(res => {
    //     const { providerName, email } = res.data;
    //     this.providerName = providerName;
    //     this.ruleForm.email = email || '';
    //   }).catch(err => {
    //     console.error(err);
    //   }).finally(() => {
    //     this.loading = false;
    //   });
    // },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message.error(this.$t('receivablePayable.unmaintainedEmail'));
          return false;
        }
        // const { email } = this.ruleForm;
        const { payableNumber } = this.row;
        // RES_OBJ.providerMail = email;
        RES_OBJ.payableNumberList = [payableNumber];
        this.asyncApiSitePayableSendMail(RES_OBJ);
      });
    },

    // 发送邮件
    asyncApiSitePayableSendMail(data) {
      this.loading = true;
      apiSitePayableSendMail(data, false).then(res => {
        this.$message.success(this.$t('GlobalSetObj.succeed'));
        this.onClose(true);
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        this.loading = false;
      });
    },

    onClose(isBool) {
      this.$emit('close', isBool);
    }
  }

};
</script>

<style lang="scss" scoped>
</style>
